export class CustomHeader extends HTMLElement {
  constructor() {
    super()
    this.mobileMenu = this.querySelector("#MobileMenu")
    this.init()
  }
  _setBodyScroll() {
    if (this.mobileMenu.hasAttribute("open")) {
      document.documentElement.classList.add("overflow-hidden")
      document.body.setAttribute("open", "")
    } else {
      document.documentElement.classList.remove("overflow-hidden")
      document.body.removeAttribute("open")
    }
  }
  _close() {
    this.mobileMenu.removeAttribute("open")
    document.body.removeAttribute("open")
  }
  init() {
    this.mobileMenu.addEventListener("toggle", () => {
      this._setBodyScroll()
    })
    this.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        this._close()
      }
    })
    document.addEventListener("click", (e) => {
      if (!e.target.closest("#MobileMenu")) {
        this._close()
        document.body.removeAttribute("open")
      }
    })
    this.height = `${this.clientHeight}px`
    document.querySelector("html").style.setProperty("--header-height", this.height)

    this.headerGroupHeights = []
    this.headerSections = document.querySelectorAll(".shopify-section-group-header-group")
    this.headerSections.forEach((section) => {
      this.headerGroupHeights.push(section.clientHeight)
    })
    const sum = this.headerGroupHeights.reduce((b, a) => b + a, 0)
    document.querySelector("html").style.setProperty("--header-group", `${sum}px`)

    this.dropdowns = this.querySelectorAll("[data-dropdown]")
    this.dropdowns.forEach((dropdown) => {
      // If we are on a mobile touch device
      if (isTouchEnabled()) {
        dropdown.querySelector("summary a").addEventListener("click", (e) => {
          e.preventDefault()
        })
      }
      dropdown.querySelector("summary").addEventListener("mouseenter", () => {
        dropdown.open = true
      })
      dropdown.addEventListener("mouseleave", () => {
        dropdown.open = false
      })
    })
  }
}

customElements.define("custom-header", CustomHeader)
